import { TrainingSessionsByEmployeeDataTableQuery } from 'generated/resources/datatable.graphql'
import {
  TrainingsSessionsDocument,
  TrainingsSessionsQueryVariables,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

type TrainingsSessionAccessMembership = NonNullable<
  NonNullable<
    NonNullable<
      NonNullable<TrainingSessionsByEmployeeDataTableQuery['trainings']>['sessionsConnection']
    >['edges'][0]
  >['node']
>

export const sortSessionsByDateAsc = (
  session1: TrainingsSessionAccessMembership,
  session2: TrainingsSessionAccessMembership
) => {
  const d1 = Date.parse(session1.startsAt)
  const d2 = Date.parse(session2.startsAt)
  const now = Date.now()

  if (isNaN(d1)) return 1
  if (isNaN(d2)) return -1
  if (d1 < now) return 1
  if (d2 < now) return -1

  return d1 - d2
}

export const useTrainingsSessions = ({
  next,
  trainingIds,
  accessId,
}: TrainingsSessionsQueryVariables) => {
  const { loading, data } = useQuery(TrainingsSessionsDocument, {
    variables: { next, trainingIds, accessId },
  })

  return {
    loading,
    sessions: data ? data.trainings.sessionsConnection.nodes.map((session) => session) : undefined,
  }
}
